const $$splitComponentImporter = () => import('/app/src/routes/session_.$sessionId.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/session_/$sessionId')({
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr)
});